
/******************************************************************************************
Finish
******************************************************************************************/

/*
  --name <string>
  --manufacturer <Manufacturer>
  --manufacturerNumber <string>
  --computerEaseNumber <string>
  --description <string::textarea>

  /Brushes

  /Buffing Products

  /Clear Topcoats and Sealers

  /Exterior Finishes

  /Finishes for Metal

  /Fire Retardant Finishes

  /Flooring Finishes

  /Gloves, Cones Strainers, Mixing Sticks, Wood Fillers, Razor Blades

  /Light Bulbs

  /Oil Finishes

  /Pigmented Primers

  /Pigmented Topcoats

  /Plastic Buckets / Metal Cans

  /Rags, Tack Cloth, Cheesecloth

  /Resiprator Parts

  /Sandpaper

  /Spray Booth Parts / Filters

  /Spray Gun Parts

  /Stain Concentrates / Dye Stains / Dispersions

  /Stains

  /Tape and Masking Paper

  /Thinners, Solvents, and Catalysts

  /Touch Up Materials

import brushes from './brushes'
import buffingProducts from './buffingProducts'
import clearTopcoatsAndSealers from './clearTopcoatsAndSealers'
import exteriorFinishes from './'
*/

/*
const files = require.context('.', false, /\.js$/)
const types = {}

files.keys().forEach(key => {
  if (key === './index.js') return
  types[key.replace(/(\.\/|\.js)/g, '')] = files(key).default
})

export default {
  name,
  id,
  types
}
*/

const name = 'Finish'
const id = 'tlczWrkrX9gljmU7dWkB'

export default {
  name,
  id
}
